import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const ChiusureConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/chiusure/broker/quotazione/add',
      component: FuseLoadable({
        loader: () => import('./Chiusure')
      })
    },
    {
      path: '/chiusure/broker/:id/add',
      component: FuseLoadable({
        loader: () => import('./Chiusure')
      })
    },
    {
      path: '/chiusure/broker/:id/:year/:month',
      component: FuseLoadable({
        loader: () => import('./Chiusure')
      })
    },
    {
      path: '/chiusure/broker/:id?',
      component: FuseLoadable({
        loader: () => import('./Chiusure')
      })
    }
  ]
}
